import { SalesforceLoginMethod } from '@modules/salesforce/models';
import * as yup from 'yup';

/**
 * Yup schema defining validation rules for Salesforce connections
 */
const ConnectionSchema = yup
  .object()
  .shape({
    name: yup.string().label('connection name').trim().required().max(256), // name
    salesforceConnectionEdition: yup
      .string()
      .label('connect with')
      .trim()
      .required(), // connect with
    loginMethod: yup.string().label('login method').trim().notRequired(), // authentication type
    isAdmin: yup.boolean().required('Is Admins'), // is admin
    username: yup.string().label('user name').trim().required(), // username
    password: yup.string().when('loginMethod', {
      is: (loginMethod: SalesforceLoginMethod) =>
        loginMethod == SalesforceLoginMethod.USERNAME_PASSWORD,
      then: (schema) => schema.required(),
      otherwise: (schema) => schema.notRequired(),
    }), // password
    securityToken: yup
      .string()
      .label('security token')
      .when('loginMethod', {
        is: (loginMethod: SalesforceLoginMethod) =>
          loginMethod == SalesforceLoginMethod.USERNAME_PASSWORD,
        then: (schema) => schema.required(),
        otherwise: (schema) => schema.notRequired(),
      }), // security token
    clientId: yup.string().label('consumer kery').trim().required(), // consumer key
    clientSecret: yup.string().required(), // consumer secret
    callbackUrl: yup.string().when('loginMethod', {
      is: (loginMethod: SalesforceLoginMethod) =>
        loginMethod == SalesforceLoginMethod.OAUTH,
      then: (schema) => schema.required(),
      otherwise: (schema) => schema.notRequired(),
    }), // callback url
    accessToken: yup.string().nullable().optional(),
    refreshToken: yup.string().nullable().optional(),
  })
  .required();

export { ConnectionSchema };
